<template>
  <sub-page title="我的证照">
    <div class="cert-page">
      <div class="cert-card" v-for="(item, idx) in certList" :key="idx">
        <div class="cert-banner">
          <div class="cert-banner-left">
            <img :src="item.icon" class="cert-icon" :alt="item.title" />
            <div class="cert-name-wrap">
              <div class="cert-title">{{ item.title }}</div>
              <div class="cert-no">{{ item.no }}</div>
            </div>
          </div>
          <span class="cert-status">{{ item.status }}</span>
        </div>
        <div class="cert-body">
          <div class="info-row"><span class="label">证书编号</span><span class="value">{{ item.no }}</span></div>
          <div class="info-row"><span class="label">发证日期</span><span class="value">{{ item.date }}</span></div>
          <div class="info-row"><span class="label">等级</span><span class="value">{{ item.level }}</span></div>
        </div>
        <div class="cert-footer">
          <button class="view-btn" @click="handleView(item)">查看证照</button>
        </div>
      </div>
      <div v-if="!certList.length" class="empty-state">
        <img :src="emptyImg" class="empty-img" alt="empty" />
        <div class="empty-text">暂无证照</div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'MyCert',
  components: { SubPage },
  data() {
    return {
      emptyImg: require('@/assets/icons/empty.png'),
      certList: [
        {
          title: '技能等级证书',
          icon: require('@/assets/icons/cert.png'),
          status: '有效',
          no: 'S2024090001',
          date: '2024-09-01',
          level: '三级/高级工'
        }
      ]
    }
  },
  methods: {
    handleView(item) {
      this.$alert('查看证照：' + item.title)
    }
  }
}
</script>

<style scoped>
.cert-page {
  background: #F3F8FB;
  min-height: 100%;
  padding: calc(24 * var(--w));
}
.cert-card {
  background: #fff;
  border-radius: calc(16 * var(--w));
  margin-bottom: calc(24 * var(--w));
  box-shadow: 0 calc(4 * var(--w)) calc(16 * var(--w)) rgba(0, 0, 0, 0.06);
  overflow: hidden;
}
.cert-banner {
  background: linear-gradient(135deg, #2E8CF6 0%, #5EA9FA 100%);
  padding: calc(32 * var(--w));
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.cert-banner::after {
  content: '';
  position: absolute;
  top: calc(-60 * var(--w));
  right: calc(-60 * var(--w));
  width: calc(220 * var(--w));
  height: calc(220 * var(--w));
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}
.cert-banner-left {
  display: flex;
  align-items: center;
  gap: calc(20 * var(--w));
  position: relative;
  z-index: 1;
}
.cert-icon {
  width: calc(80 * var(--w));
  height: calc(80 * var(--w));
  object-fit: contain;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.95);
  border-radius: calc(14 * var(--w));
  padding: calc(10 * var(--w));
}
.cert-name-wrap {
  display: flex;
  flex-direction: column;
  gap: calc(8 * var(--w));
}
.cert-title {
  font-size: calc(32 * var(--w));
  color: #fff;
  font-weight: 600;
}
.cert-no {
  font-size: calc(24 * var(--w));
  color: rgba(255, 255, 255, 0.85);
}
.cert-status {
  font-size: calc(22 * var(--w));
  color: #fff;
  background: rgba(255, 255, 255, 0.22);
  padding: calc(6 * var(--w)) calc(18 * var(--w));
  border-radius: calc(20 * var(--w));
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}
.cert-body {
  padding: calc(20 * var(--w)) calc(32 * var(--w));
  display: flex;
  flex-direction: column;
}
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: calc(16 * var(--w)) 0;
}
.info-row:not(:last-child) {
  border-bottom: 1px dashed #EBEDF0;
}
.label {
  font-size: calc(28 * var(--w));
  color: #969799;
}
.value {
  font-size: calc(28 * var(--w));
  color: #323233;
  font-weight: 500;
}
.cert-footer {
  padding: 0 calc(32 * var(--w)) calc(28 * var(--w));
}
.view-btn {
  width: 100%;
  height: calc(72 * var(--w));
  background: rgba(46, 140, 246, 0.08);
  color: #2E8CF6;
  font-size: calc(28 * var(--w));
  border: none;
  border-radius: calc(36 * var(--w));
  cursor: pointer;
  transition: background 0.2s;
}
.view-btn:active {
  background: rgba(46, 140, 246, 0.15);
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: calc(160 * var(--w));
}
.empty-img {
  width: calc(240 * var(--w));
  height: calc(240 * var(--w));
  object-fit: contain;
  opacity: 0.9;
}
.empty-text {
  margin-top: calc(24 * var(--w));
  font-size: calc(30 * var(--w));
  color: #969799;
}
</style>



// WEBPACK FOOTER //
// src/pages/MyCert.vue